






import { Component, Vue, Prop } from "vue-property-decorator";
import { ChartColors, ChartConstants } from "@/constants/chart";
import { AreaExpansionChartDTO } from '@/api/analyses/types';

@Component({
  name: "AreaExpansionChartRenderer",
})
export default class AreaExpansionChartRenderer extends Vue {
  @Prop({ type: Array, required: true })
  private areaExpansionList!: AreaExpansionChartDTO[];

  @Prop({ type: String, required: false })
  private title!: string;

  @Prop({ type: String, required: false, default: "#000" })
  private backgroundColor!: string;

  private getLabels(list: AreaExpansionChartDTO[]) {
    return list.map(item => item.harvestYear);
  }

  private formatFloat(value: number) {
    return value ? parseFloat(value.toFixed(2)): 0.0;
  }

  private getData(list: AreaExpansionChartDTO[]) {
    const labelsAux = list.map(item => item.harvestYear);

    const data1 = {
      name:  this.$t("charts.area-expansion.arable-area"),
      backgroundColor: ChartColors.ARABLE_AREA,
      color: ChartColors.ARABLE_AREA,
      yAxisID: "y-axis-1",
      data: list.map(item => this.formatFloat(item.arableArea)),
      fill: false,
    };
          
    const data2 = {
      name:  this.$t("charts.area-expansion.crop-area"),
      backgroundColor: ChartColors.CROP_AREA,
      color: ChartColors.CROP_AREA,
      yAxisID: "y-axis-2",
      data: list.map(item => this.formatFloat(item.cropArea)),
      fill: false,
    };

    const data3 = {
      name: this.$t("charts.area-expansion.total-area"),
      backgroundColor: ChartColors.TOTAL_AREA,
      dashStyle: 'ShortDash',
      color: ChartColors.TOTAL_AREA,
      yAxisID: "y-axis-3",
      data: list.map(item => this.formatFloat(item.totalArea)),
      fill: true,
    };


    return [data3, data1, data2];
  }

  get chartOptions() {
    return {
      chart: {
        style: {
          fontFamily: ChartConstants.FONT_FAMILY
        },
        backgroundColor: ChartColors.BACKGROUND,
      },
      credits: {
        enabled: false,
      },
      title: {
        text: this.title,
        style: ChartConstants.TITLE_STYLE,
        align: 'left'
      },
      xAxis: {
        categories: this.getLabels(this.areaExpansionList),
      },
      yAxis: {
        title: {
            text: ''
        }
      },
      legend: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'top'
      },
      plotOptions: {
        series: {
          label: {
              connectorAllowed: false
          },
        }
      },
      series: this.getData(this.areaExpansionList),
      responsive: {
        rules: [{
          condition: {
            maxWidth: 500
          },
          chartOptions: {
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom'
            }
          }
        }]
      }
    };
  }
}

